import { FaGithubSquare } from "react-icons/fa";
import { ImFacebook2 } from "react-icons/im";
import { GrInstagram } from "react-icons/gr";
import { BsLinkedin, BsDiscord } from "react-icons/bs";
import "./Footer.scss";

const Footer = () => {
  return (
    <div className="main-footer">
      <div className="container">
        <div className="row">
          <div className="col-12 mx-auto ">
            <ul className="text-center footer-list">
              <li className="icon-linkln">
                <a
                  href="https://www.linkedin.com/in/ahmeraltaf7/"
                  target="_blank"
                  className="linkln-link"
                >
                  <BsLinkedin />
                </a>
              </li>
              <li className="icon-github">
                <a
                  href="https://github.com/ahmeraltaf7"
                  target="_blank"
                  className="github-link"
                >
                  <FaGithubSquare />
                </a>
              </li>
              <li className="icon-facebook">
                <a
                  href="https://www.facebook.com/ramboahmer.altaf/"
                  target="_blank"
                  className="facebook-link"
                >
                  <ImFacebook2 />
                </a>
              </li>
              <li className="icon-insta">
                <a
                  href="https://www.instagram.com/ahmer_o_o/"
                  target="_blank"
                  className="insta-link"
                >
                  <GrInstagram />
                </a>
              </li>
              <li className="icon-discord">
                <a
                  href="https://www.discordapp.com/users/Ahmer#2716"
                  target="_blank"
                  className="discord-link"
                >
                  <BsDiscord />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-12 mx-auto">
            <p className="text-center text-white pb-3">
              &copy; {new Date().getFullYear()} Ahmer Altaf. All rights
              reserved. Built using React.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
